'use client';

import type { ComponentProps } from 'react';

import Link from '@/components/NoPrefetchLink';

type Props = ComponentProps<typeof Link> & {
  competitionId: string;
  teamId: string | null;
};

export default function InternationalCompetitionContextLink({
  competitionId: _competitionId,
  teamId: _teamId,
  ...props
}: Props) {
  void _competitionId;
  void _teamId;
  return <Link {...props} />;
}
